<template>
  <main class="c-pagedesigner page-designer-reference main-content main-content--mobile page" id="main-content" style="padding-top: 0px;">
    <div class="col-12 px-2 c-strat__container">
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat2">
              <div class="c-strat2 c-background js_strat layout layout--full-width" style="">
                <div class="c-strat2__main-image c-background__content-wrapper js_strat_main_image null">
                  <div class="layout">
                    <div class="c-background__content">
                      <div class="ms-row center-xs">
                        <div class="col-xs-10 col-md-6">
                          <div class="c-strat2__title-wrapper">
                            <span class="c-strat2__title" style="color: null">
                              <h2><span style="color: rgb(0, 0, 0);">SISLEY的专业知识</span></h2>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="ms-row center-xs">
                        <div class="col-xs-12">
                          <div class="c-strat2__image-wrapper">
                            <img class=" lazyloaded" alt="Sisley护肤品兼具卓越功效和奢悦感官享受。" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel1.jpg">
                          </div>
                        </div>
                      </div>
                      <div class="ms-row center-xs full-width">
                        <div class="col-xs-10 col-md-8">
                          <div class="c-strat2__title-wrapper-bottom">
                            <div class="c-strat2__big-p" style="color: null">
                              <p><span style="color: rgb(0, 0, 0);">四十多年来，Sisley潜心致力于使用创新成分和配方打造美容护肤产品，在兼顾肌肤完整性与和谐感的同时，将卓越功效与奢悦感官享受合二为一。</span></p>
                            </div>
                            <div class="c-strat2__regular-p" style="color: null">
                              <p><span style="color: rgb(0, 0, 0);">品牌研究实验室以全球美容保养策略为核心，展现其强大且独特的研发能力。实验室透彻了解肌肤的多样性，包括生理机制及环境，并将其与Sisley独有的植物美容学理念融为一体。</span></p>
                              <p><span style="color: rgb(0, 0, 0);">Sisley的每款产品都荟萃了大自然的精粹与卓越科研成果，既拥有卓越的护理功效，又能带来舒悦的使用感，品牌全球盛誉由此而来。</span></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="background-color: #F6F4F1;">
          <div class="layout c-strat3">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="c-strat3__title-wrapper">
                  <div class="c-strat3__subtitle" style="color: null">
                    <p><span style="color: rgb(0, 0, 0);">不计时间，追求卓越</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended ">
                    <img class=" lazyloaded" alt="时间永远不会阻碍Sisley研发脚步。" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel2.jpg">
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p><span style="color: rgb(0, 0, 0);">我们的理念，不仅是品牌特色之所在，亦是产品大受好评之秘诀。</span></p>
                        <p><br></p><p><span style="color: rgb(0, 0, 0);">Sisley是一间由追求美丽、有高度热情的领导者管理的法国公司，致力于在化妆品的各个阶段和各个品类中追求卓越。 </span></p>
                        <p><br></p><p><span style="color: rgb(0, 0, 0);">我们的研发团队拥有充裕的时间来自主研发配方，以获得能满足安全标准的卓越成果。 </span></p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended ">
                    <img class=" lazyloaded" alt="" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel3.jpg">
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p><span style="color: rgb(0, 0, 0);">我们采用严谨且耐心的科研方法，以四十多年的丰富经验为基础，以研发开创性产品为己任。</span></p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended ">
                    <img class=" lazyloaded" alt="" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel21.jpg">
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p><span style="color: rgb(0, 0, 0);">Sisleÿa是品牌推出的首款标志性护肤产品，一经问世便广获全球好评，是长达十多年研究的成果。其复合配方蕴含了多种不同的植物活性抗老成分，可同时针对不同肌肤类型，带来多方位的抗老效果。</span></p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9">
                        <div class="c-button-wrapper">
                          <a href="/detail?id=255" class="c-button c-button--secondary c-button--null c-input--fullwidth c-pagedesigner__button-space">
                          了解更多
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width c-strat1__margin-top c-strat1--image" style="">
          <div class="c-strat1__background js_strat_background c-background__image-container">
          <img class="show-for-md c-background__image js-image--large" src="@/assets/imgs/CMS-pages/expertise-sisley/background1-hk.jpg">
          <img class="hide-for-md c-background__image js-image--small" src="@/assets/imgs/CMS-pages/expertise-sisley/background1-mobie-hk.jpg">
          </div>
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image has-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content"></div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowA">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
                <div class="ms-row c-strat1--rowA--last">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width  null" style="">
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image no-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content">
                <div class="col-xs-12 col-md-6">
                  <div class="c-pagedesigner__title-wrapper ">
                    <div class="c-pagedesigner__subtitle reset-style" style="color: null">
                      <p><span style="color: rgb(0, 0, 0);">肌肤是个特别的器官，是人体的天然保护机制。但这层防护盾也很脆弱，随着时间的流逝或受到外在刺激，衰老和受损的问题也逐渐出现。</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowA">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><br></p><p><span style="color: rgb(0, 0, 0);">Sisley凭借对肌肤生理机制的深入了解，以此为基础制定出适用于各类肤质、各种年龄和各种肤色的多方位护肤方案，以满足因天气和环境差异而产生的不同肌肤需求。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">Sisley的配方经过精心设计，可满足不同需求，如抗老化、彩妆、卸妆及防晒护理等。Sisley推出的护理产品种类齐全，可用于面部、身体、特定区域（如前胸、眼周、颈部和唇周），此外还有「Hair Rituel by Sisley」专业护发品牌。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">为了确保护肤成效，我们的产品将常见肌肤问题影响因素纳入考虑，包含内在因素（缺水、油脂分泌旺盛、肌肤老化、荷尔蒙失衡等），外在和行为影响因素（日晒伤害，生活方式等）。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
                <div class="ms-row c-strat1--rowA--last">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width  c-strat1--image" style="">
          <div class="c-strat1__background js_strat_background c-background__image-container">
            <img class="show-for-md c-background__image js-image--large" src="@/assets/imgs/CMS-pages/expertise-sisley/background2-hk.jpg">
            <img class="hide-for-md c-background__image js-image--small" src="@/assets/imgs/CMS-pages/expertise-sisley/background2-mobile-hk.jpg">
          </div>
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image has-image" style="min-height: 994px;">
            <div class="layout">
              <div class="ms-row  c-background__content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width  null" style="">
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image no-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content">
                <div class="col-xs-12 col-md-6">
                  <div class="c-pagedesigner__title-wrapper ">
                    <div class="c-pagedesigner__subtitle" style="color: null">
                      <p><span style="color: rgb(0, 0, 0);">大自然的力量</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowA">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">大自然是神奇的，巨大的潜力尚未被完全开发。地球共有600,000多种植物，人类只辨识出其中的300,000种（包括植物和真菌），这还不包括海洋植物。其中，只有不到20%的物种被用于科学研究。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">生长于陆地和海洋的植物、树木和花卉都具备令人惊叹的神奇功效。它们凝聚生命的能量，拥有再生、保护和适应的能力。这些特点使它们能够在不同的环境下生存，适应各类极端严苛的条件，同时使自己免遭伤害。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">源自植物界的多种重要成分早已展示出了卓越的功效和耐受性，如今已被广泛应用在各个行业和领域，特别是在医药领域。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">Sisley研发部拥有一支专业的多学科研究团队，由植物学家、化学家、生物学家、药剂师和工程师组成。他们不断研究自然知识，为了了解、模仿和找出有价值及功效可利用的植物物种和关键成分，为肌肤保养带来卓越的作用。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ms-row c-strat1--rowA--last">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_b">
                      <div class="c-strat4__content-wrapper col-xs-10 col-sm-9 col-md-8">
                        <div class="c-strat4__subtitle md-text--center" style="color: null">
                          <p><span style="color: rgb(0, 0, 0);">对植物世界的透彻了解</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img class="c-strat4__image lazyloaded" alt="Sisley擅长运用植物学专业知识。" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel5.jpg">
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0);">植物具有的非凡特性，取决于多种内外因素（来源、物种、品种、气候等）。<br /><br />
在四十多年间，Sisley研发团队始终专注于植物世界的研究。团队成员精心甄选来自世界各地的植物，以提取其重要成分。当中既有异域物种，也有本土植物，既有野生作物，也有培植物种。在选择植物的同时，他们也没忘记保护生物多样性。除个别配方为有机成分，其余均是在遵守可持续发展农业协议的前提下进行种植。<br /><br />
这些活性萃取的成分可能源自花朵、茎秆、叶片、根部、种子或果实。遴选过程还会考虑到多种因素，如作物的产地、收成时期和萃取技术。这项工作每年都会更新，以便从植物中获取天然的精粹成分。 <br /><br />
例如，生长在野生环境下的积雪草富含多种重要成分，因而拥有卓越的美肌功效。相反情况下，人工种植的积雪草则不包含任何能够用于护肤的重要成分。因此，Sisley研发团队选择了产自马达加斯加的积雪草。它以野生状态生长于山顶，产地面积相当于法国的科西嘉岛，而且为了获得卓越的分子关键浓度，一年只集中采收一次。<br /><br />
再举一个例子：巴卡拉黑玫瑰萃取物是黑玫瑰焕采系列的核心配方之一，它从花卉的花瓣中提取而来。Sisley研发团队之所以选择这个特殊的部位，是因为它富含多酚抗氧化成分和具有收敛功效的单宁。这种萃取物必须在开花期的早期提取，以避免过多的紫外线破坏其重要分子。</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_b">
                      <div class="c-strat4__content-wrapper col-xs-10 col-sm-9 col-md-8">
                        <div class="c-strat4__subtitle md-text--center" style="color: null">
                          <p><span style="color: rgb(0, 0, 0);">以科学为基础，获取纯净而天然的卓越成分。</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img class="c-strat4__image lazyloaded" alt="Sisley的每个配方，都蕴含植物之精粹。" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel6.jpg">
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0);">Sisley研发团队将传统工艺与高科技相结合，打造出独有的萃取方式。这些技术可保留植物的完整性及特色，以获取纯净的高质量精粹成分。 </span></p>
                            <p><br></p>
                            <p><span style="color: rgb(0, 0, 0);">Sisley研发团队同时采用传统的物理萃取方法（冷压、浸渍和蒸馏）以及领先技术（「二氧化碳超临界萃取法」）。植物的所有活性成分（糖原、蛋白质、脂质……）都得到完整保存和萃取，使其成分中的丰富养分能够发挥效用。</span></p>
                            <p><br></p>
                            <p><span style="color: rgb(0, 0, 0);">所有天然成分都被滴定提取，可确保Sisley产品配方中的每种关键成分在质量、数量和纯度方面都能尽善尽美。</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width  c-strat1--image" style="">
          <div class="c-strat1__background js_strat_background c-background__image-container">
            <img class="show-for-md c-background__image js-image--large" src="@/assets/imgs/CMS-pages/expertise-sisley/background3-hk.jpg">
            <img class="hide-for-md c-background__image js-image--small" src="@/assets/imgs/CMS-pages/expertise-sisley/background3-mobile-hk.jpg">
          </div>
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image has-image" style="min-height: 959px;">
            <div class="layout">
              <div class="ms-row  c-background__content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width  null" style="">
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image no-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content">
                <div class="col-xs-12 col-md-6">
                  <div class="c-pagedesigner__title-wrapper ">
                    <div class="c-pagedesigner__subtitle" style="color: null">
                      <p><span style="color: rgb(0, 0, 0);">黄金比例与协同作用</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowA">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">Sisley研究实验室在对肌肤透彻了解的基础上，致力于以高效率实现每项美肌目标。为了达成这一目的，研究人员开发出了极尽完整的复杂配方，将数量繁多的重要成分融为一体，而这则需要以漫长且细致的研发进程为基础。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">产品配方的有效性取决于以下三大指标：浓度、剂量和协同作用，四十多年来的心血钻研，再加上前沿科技的探索成果，使得研究人员得以透彻了解所有活性成分的功效，进而确保三大指标的卓越成效。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs ">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">此外，Sisley产品还包含了高浓度的关键成分，其中一些成分超过配方的20%。每种成分的剂量均经过仔细研究，追求发挥耐受性的同时，实现卓越的功效。正是这项精准而复杂的操作，缔造了品牌产品的口碑。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
                <div class="ms-row c-strat1--rowA--last">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_b">
                      <div class="c-strat4__content-wrapper col-xs-10 col-sm-9 col-md-8">
                        <div class="c-strat4__subtitle md-text--center" style="color: null">
                          <p><span style="color: rgb(0, 0, 0);">奢悦感官享受</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img class="c-strat4__image lazyloaded" alt="Sisley产品赋予舒悦的感官享受。" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel7.jpg">
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0);">自品牌创立初始，Sisley便致力于将热情与技术合二为一，不断改善其产品的使用感受。Sisley的创始人参与到了每款产品的研发进程当中。我们坚信：护肤品应当是将愉悦性与有效性完美结合，不仅仅是单纯的护肤，更代表了一段关爱自我的愉悦时光。<br /><br />
                            不论是精华、啫喱还是面霜或乳液，每款Sisley的产品都经过精心设计，以达到质感与配方之间的理想平衡，使产品能彻底发挥其全部功效。</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width  null" style="">
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image no-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content"></div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowB">
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <img class=" lazyloaded" alt="Hydra-Global Sérum, gel-crème à texture aqueuse" src="@/assets/imgs/CMS-pages/expertise-sisley/texture1.jpg">
                            </div>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left subtitle-content" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">举个例子，赋活水润保湿精华是一款啫喱精华，拥有令人惊艳的水状质地，能够实时深层滋润肌肤，持久保湿，带来清爽舒适的护肤体验。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <img class=" lazyloaded" alt="Baume à la Rose Noire, un baume «à transformation»" src="@/assets/imgs/CMS-pages/expertise-sisley/texture2.jpg">
                            </div>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left subtitle-content" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">黑玫瑰焕采精华霜是一款「质感变换」的面霜，涂抹时一触即融，在接触肌肤的瞬间，面霜顷刻幻化为无数微细水珠，实时融入肌肤，带来清爽舒适的感受，让肌肤持久水润。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row  center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <img class=" lazyloaded" alt="Le Phyto Rouge" src="@/assets/imgs/CMS-pages/expertise-sisley/texture3.jpg">
                            </div>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left subtitle-content" style="color: null">
                                <p><span style="color: rgb(0, 0, 0);">魅惑口红中添加了护肤成分，拥有唇膏的浓郁色彩，质地却宛若润唇膏般润泽丝滑。在与双唇接触的瞬间，其凝胶质地立刻转变为液体，带来无与伦比的舒适感受，同时为双唇添上明艳、动人的持久色彩。</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ms-row c-strat1--rowB--last">
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_a">
                      <div class="col-sm-5 hide-for-xs-only hide-for-sm-only c-strat4__image-container">
                        <div class="c-strat4__image-wrapper c-strat4__wrapper_a">
                          <div class="">
                            <img class="c-strat4__image lazyloaded" alt="" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel8.jpg">
                          </div>
                        </div>
                      </div>
                      <div class="c-strat4__content-wrapper text--no-margin col-xs-10 col-sm-9 col-md-offset-1 col-md-5">
                        <div class="c-strat4__subtitle reset-style" style="color: null">
                          <p><span style="color: rgb(0, 0, 0);">Sisley通过其产品配方，很大程度地发挥了植物精油的功效。每种精油均经过精心甄选，其净度和功效可完美符合产品需求。</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img class="lazyloaded c-strat4__image" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel8.jpg" alt="">
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0);">它们不仅能进一步优化产品功效（例如清洁、润肤和舒缓），还能为其添加一缕自然的芬芳。</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">源自「Hair Rituel by Sisley」秀发护理品牌的天然香氛便是我们的经典香氛之一。</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="background-color: #F0EBE4;">
          <div class="layout c-strat3">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="c-strat3__title-wrapper">
                  <div class="c-strat3__subtitle" style="color: null">
                    <p><span style="color: rgb(0, 0, 0);">功效与耐受性</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended ">
                    <img class=" lazyloaded" alt="Sisley产品将功效与耐受性合二为一。" src="@/assets/imgs/CMS-pages/expertise-sisley/visuel9.jpg">
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p><span style="color: rgb(0, 0, 0);">我们的目标，是打造产品功效与耐受性的卓越组合。产品的功效与安全性不仅通过了品牌专业研究团队的评估，亦得到了来自法国独立实验室的安全评估员、临床专家和皮肤科医生的认可。</span></p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-2column">
        <div class="c-pagedesigner__module-space c-pagedesigner__module-space-background" style="background-color: #f6f6f6;">
          <div class="layout">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-md-8 col-lg-6">
                <div class="c-pagedesigner__title-wrapper">
                  <h3 class="c-pagedesigner__title heading-h3 text--center c-pagedesigner__text-content">探索更多</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="layout">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-6">
                <div class="experience-component experience-assets-editorialpush">
                  <div class="c-editorial-push c-content-carousel__item">
                    <a href="/entreprise" class="c-text-image c-text-image–-secondary">
                      <div class="c-text-image__visual">
                        <img class=" lazyloaded" alt="" src="@/assets/imgs/CMS-pages/expertise-sisley/rebond-entreprise.jpg">
                        <div class="c-text-image__visual-title c-text-image__visual-title--thin">
                          <div class="c-text-image__visual-title--uppercase">关于公司</div>
                          Sisley
                        </div>
                      </div>
                      <div class="c-text-image__content start-xs">
                        <div class="c-text-image__text">
                          <div class="c-text-image__description">敢于创新的法国家族企业</div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="experience-component experience-assets-editorialpush">
                  <div class="c-editorial-push c-content-carousel__item">
                    <a href="/sisley-x-environment" class="c-text-image c-text-image–-secondary">
                      <div class="c-text-image__visual">
                        <img class=" lazyloaded" alt="" src="@/assets/imgs/CMS-pages/expertise-sisley/rebond-beauteRaisonnee.jpg">
                        <div class="c-text-image__visual-title c-text-image__visual-title--thin">
                          <div class="c-text-image__visual-title--uppercase">永续</div>
                          美丽
                        </div>
                      </div>
                      <div class="c-text-image__content start-xs">
                        <div class="c-text-image__text">
                          <div class="c-text-image__description">Sisley持续关注并以行动落实对大自然的保护以及环境的可持续发展</div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-topCategoryPD">
              <div class="js-pagedesigner-id sr-only" data-pd-id="expertise-sisley"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    name: "ExpertiseSisley",
    mounted() {
        setTimeout(()=>{
          this.initElements()
        },2000)
    },
    methods: {
      initElements() {
        Array.from(document.querySelectorAll(".js_strat_main_image")).forEach(dom => {
          let bgImgSelector = "", extraHeight = 0;
          if (window.innerWidth >= 1024) {
            bgImgSelector = ".js-image--large";
          } else {
            bgImgSelector = ".js-image--small";
            extraHeight = 150;
          }
          let bgImg = dom.parentElement.querySelector(bgImgSelector)
          bgImg && dom.style.setProperty("min-height", bgImg.getBoundingClientRect().height - extraHeight + "px");
        });
      }
    }
  }
</script>

<style lang="css" scoped>
  .page{overflow-x: hidden;}
  .hidden{display:none}
  html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}
  article,aside,footer,header,nav,section{display:block}
  h1{font-size:2em;margin:.67em 0}
  figcaption,figure,main{display:block}
  figure{margin:1em 40px}
  hr{box-sizing:content-box;height:0;overflow:visible}
  pre{font-family:monospace,monospace;font-size:1em}
  a{background-color:transparent;-webkit-text-decoration-skip:objects}
  a:active,a:hover{outline-width:0}
  abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}
  b,strong{font-weight:inherit;font-weight:bolder}
  code,kbd,samp{font-family:monospace,monospace;font-size:1em}
  dfn{font-style:italic}
  mark{background-color:#ff0;color:#000}
  sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}
  sub{bottom:-.25em}
  sup{top:-.5em}
  audio,video{display:inline-block}
  audio:not([controls]){display:none;height:0}
  img{border-style:none}
  svg:not(:root){overflow:hidden}
  button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}
  button,input{overflow:visible}
  button,select{text-transform:none}
  [type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}
  [type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}
  [type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}
  fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}
  legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}
  progress{display:inline-block;vertical-align:baseline}
  textarea{overflow:auto}
  [type=checkbox],[type=radio]{box-sizing:border-box;padding:0}
  [type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}
  [type=search]{-webkit-appearance:textfield;outline-offset:-2px}
  [type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}
  ::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}
  details,menu{display:block}
  summary{display:list-item}
  canvas{display:inline-block}
  [hidden],template{display:none}
  blockquote,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,pre,td,th,ul{margin:0;padding:0}
  em,i{font-style:italic}
  b,em,i,strong{line-height:inherit}
  b,strong{font-weight:700}
  small{font-size:80%;line-height:inherit}
  address{font-style:normal}
  dl,ol,ul{line-height:1.6;margin-bottom:1rem;list-style-position:outside}
  li{font-size:inherit}
  ul{list-style-type:none}
  ol,ul{margin-left:0}
  ol ol,ol ul,ul ol,ul ul{margin-left:0;margin-bottom:0}
  p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}
  .heading-h1,.heading-h2,.heading-h3,.heading-h4,.heading-h5,.heading-h6,h1,h2,h3,h4,h5,h6{color:#000;margin-top:0;margin-bottom:.5rem}
  .heading-h1,h1{font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.16}
  .heading-h2,.heading-h4,.heading-h6,h2,h4,h6{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;font-style:normal}
  .heading-h3,h3{text-transform:uppercase;letter-spacing:.0625rem;display:block}
  .heading-h3,.heading-h5,h3,h5{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.66}
  .heading-h5,h5{letter-spacing:normal}
  .heading-h2,h2{line-height:1.32}
  .heading-h4,.heading-h6,h4,h6{line-height:1.5}
  .heading-h1,.heading-h2,h1,h2{font-size:1.5625rem}
  .heading-h3,h3{font-size:.75rem}
  .heading-h4,h4{font-size:1rem}
  .heading-h5,h5{font-size:.75rem}
  .heading-h6,h6{font-size:.875rem}
  @media screen and (min-width:48em){.heading-h1,h1{font-size:2.1875rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
  @media screen and (min-width:64em){.heading-h1,h1{font-size:3.125rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
  .link,a{color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.75rem;text-decoration:underline;line-height:inherit;cursor:pointer}
  .link:focus,a:focus{text-decoration:none}
  @media screen and (min-width:75em){.link:hover,a:hover{text-decoration:none}}
  .link img,a img{border:0}
  html{font-size:100%;box-sizing:border-box}
  @media screen and (min-width:64em){html{overflow-x:hidden}}
  *,:after,:before{box-sizing:inherit}
  body{padding:0;margin:0;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;line-height:1.6;font-size:.8125rem;color:#575757;background:#fff;overflow-x:hidden;opacity:1;transition:opacity 1s;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
  body.fade-out{opacity:0;transition:none}
  body:not(.popin-open):not(.no-scroll):not(.js-no-scroll){-webkit-overflow-scrolling:touch}
  body.mouse-clicked a:focus,body.mouse-clicked a:focus-within,body.mouse-clicked area:focus,body.mouse-clicked area:focus-within,body.mouse-clicked button:focus,body.mouse-clicked button:focus-within,body.mouse-clicked div:focus,body.mouse-clicked div:focus-within,body.mouse-clicked iframe:focus,body.mouse-clicked iframe:focus-within,body.mouse-clicked input:focus,body.mouse-clicked input:focus-within,body.mouse-clicked select:focus,body.mouse-clicked select:focus-within,body.mouse-clicked textarea:focus,body.mouse-clicked textarea:focus-within{outline:none!important;outline-width:0!important;box-shadow:none!important;-moz-box-shadow:none!important;-webkit-box-shadow:none!important}
  body.mouse-clicked a:after,body.mouse-clicked a:before,body.mouse-clicked area:after,body.mouse-clicked area:before,body.mouse-clicked button:after,body.mouse-clicked button:before,body.mouse-clicked div:after,body.mouse-clicked div:before,body.mouse-clicked iframe:after,body.mouse-clicked iframe:before,body.mouse-clicked input:after,body.mouse-clicked input:before,body.mouse-clicked select:after,body.mouse-clicked select:before,body.mouse-clicked textarea:after,body.mouse-clicked textarea:before{outline-color:transparent!important}
  .text--bold{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
  .text--no-margin{margin:0}
  fieldset{border:0;padding:0;margin:0}
  textarea{height:auto;min-height:50px}
  select{width:100%;z-index:1!important}
  button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:0;line-height:1}
  input::-webkit-credentials-auto-fill-button{visibility:hidden;display:none;pointer-events:none;position:absolute;right:0}
  form{position:relative}
  .disabled{pointer-events:none}
  img{-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}
  img,object,video{max-width:100%;height:auto}
  video::-webkit-media-controls-start-playback-button{display:none}
  .lazyload{opacity:0}
  .lazyloading{opacity:.25;transition:opacity .2s}
  .lazyloaded{opacity:1;transition:opacity .2s}
  .image--full-width{width:100%}
  .image--contain{object-fit:contain;object-position:center}
  .container,.container-fluid{margin-right:auto;margin-left:auto}
  .container{width:100%;max-width:75rem}
  .container-fluid{padding-right:2rem;padding-left:2rem}
  .col.reverse{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}
  .flex-column{flex-direction:column}
  .col-xs,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-offset-0,.col-xs-offset-1,.col-xs-offset-2,.col-xs-offset-3,.col-xs-offset-4,.col-xs-offset-5,.col-xs-offset-6,.col-xs-offset-7,.col-xs-offset-8,.col-xs-offset-9,.col-xs-offset-10,.col-xs-offset-11,.col-xs-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
  .col-xs{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
  .col-xs-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
  .col-xs-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
  .col-xs-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
  .col-xs-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
  .col-xs-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
  .col-xs-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
  .col-xs-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
  .col-xs-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
  .col-xs-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
  .col-xs-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
  .col-xs-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
  .col-xs-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
  .col-xs-offset-0{margin-left:0}
  .col-xs-offset-1{margin-left:8.33333333%}
  .col-xs-offset-2{margin-left:16.66666667%}
  .col-xs-offset-3{margin-left:25%}
  .col-xs-offset-4{margin-left:33.33333333%}
  .col-xs-offset-5{margin-left:41.66666667%}
  .col-xs-offset-6{margin-left:50%}
  .col-xs-offset-7{margin-left:58.33333333%}
  .col-xs-offset-8{margin-left:66.66666667%}
  .col-xs-offset-9{margin-left:75%}
  .col-xs-offset-10{margin-left:83.33333333%}
  .col-xs-offset-11{margin-left:91.66666667%}
  .display-flex-xs{display:-webkit-box;display:-ms-flexbox;display:flex}
  .ms-row.reversed{-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}
  .ms-row,.ms-row.reversed{-webkit-box-orient:horizontal}
  .ms-row{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-.625rem;margin-left:-.625rem}
  .flex-nowrap-md{flex-wrap:nowrap}
  .flex-wrap{flex-wrap:wrap}
  .ms-row--second{margin-left:-.5rem;margin-right:-.5rem}
  .ms-row--second .col-xs,.ms-row--second .col-xs-1,.ms-row--second .col-xs-2,.ms-row--second .col-xs-3,.ms-row--second .col-xs-4,.ms-row--second .col-xs-5,.ms-row--second .col-xs-6,.ms-row--second .col-xs-7,.ms-row--second .col-xs-8,.ms-row--second .col-xs-9,.ms-row--second .col-xs-10,.ms-row--second .col-xs-11,.ms-row--second .col-xs-12,.ms-row--second .col-xs-offset-0,.ms-row--second .col-xs-offset-1,.ms-row--second .col-xs-offset-2,.ms-row--second .col-xs-offset-3,.ms-row--second .col-xs-offset-4,.ms-row--second .col-xs-offset-5,.ms-row--second .col-xs-offset-6,.ms-row--second .col-xs-offset-7,.ms-row--second .col-xs-offset-8,.ms-row--second .col-xs-offset-9,.ms-row--second .col-xs-offset-10,.ms-row--second .col-xs-offset-11,.ms-row--second .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
  .ms-row--third{margin-left:-.5rem;margin-right:-.5rem}
  @media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third{margin-left:-.75rem;margin-right:-.75rem}}
  .ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
  @media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.75rem;padding-left:.75rem}}
  @media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-sm--left{padding-left:calc(8.33333% - .75rem)} .ms-row--third .col-padding-sm--right{padding-right:calc(8.33333% - .75rem)}}
  .ms-row--third .col-padding-xs{padding:0 calc(8.33333% - .5rem)}
  @media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-xs{padding-right:.75rem;padding-left:.75rem}}
  @media screen and (min-width:64em){.ms-row--third .col-padding-xs{padding-right:.5rem;padding-left:.5rem}}
  .ms-row--third .col-xs--expanded-right{padding:0 calc(8.33333% - .5rem) 0 .5rem}
  @media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-right{padding-right:.75rem;padding-left:.75rem}}
  @media screen and (min-width:64em){.ms-row--third .col-xs--expanded-right{padding-right:.5rem;padding-left:.5rem}}
  .ms-row--third .col-xs--expanded-left{padding:0 .5rem 0 calc(8.33333% - .5rem)}
  @media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-left{padding-right:.75rem;padding-left:.75rem}}
  @media screen and (min-width:64em){.ms-row--third .col-xs--expanded-left{padding-right:.5rem;padding-left:.5rem}}
  .ms-row.collapsed{margin-left:0;margin-right:0}
  .ms-row.collapsed .col-xs,.ms-row.collapsed .col-xs-1,.ms-row.collapsed .col-xs-2,.ms-row.collapsed .col-xs-3,.ms-row.collapsed .col-xs-4,.ms-row.collapsed .col-xs-5,.ms-row.collapsed .col-xs-6,.ms-row.collapsed .col-xs-7,.ms-row.collapsed .col-xs-8,.ms-row.collapsed .col-xs-9,.ms-row.collapsed .col-xs-10,.ms-row.collapsed .col-xs-11,.ms-row.collapsed .col-xs-12,.ms-row.collapsed .col-xs-offset-0,.ms-row.collapsed .col-xs-offset-1,.ms-row.collapsed .col-xs-offset-2,.ms-row.collapsed .col-xs-offset-3,.ms-row.collapsed .col-xs-offset-4,.ms-row.collapsed .col-xs-offset-5,.ms-row.collapsed .col-xs-offset-6,.ms-row.collapsed .col-xs-offset-7,.ms-row.collapsed .col-xs-offset-8,.ms-row.collapsed .col-xs-offset-9,.ms-row.collapsed .col-xs-offset-10,.ms-row.collapsed .col-xs-offset-11,.ms-row.collapsed .col-xs-offset-12{padding-right:0;padding-left:0}
  .ms-row.expanded{margin-right:-.625rem;margin-left:-.625rem}
  .flex-fill{flex-grow:1}
  .start-xs{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
  .center-xs{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
  .end-xs{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
  .top-xs{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
  .middle-xs{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
  .bottom-xs{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
  .self-bottom-xs{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
  .around-xs{-ms-flex-pack:distribute;justify-content:space-around}
  .between-xs{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .first-xs{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
  .last-xs{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
  @media screen and (min-width:48em){
    .col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-offset-0,.col-sm-offset-1,.col-sm-offset-2,.col-sm-offset-3,.col-sm-offset-4,.col-sm-offset-5,.col-sm-offset-6,.col-sm-offset-7,.col-sm-offset-8,.col-sm-offset-9,.col-sm-offset-10,.col-sm-offset-11,.col-sm-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
    .col-sm{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
    .col-sm-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
    .col-sm-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
    .col-sm-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
    .col-sm-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
    .col-sm-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
    .col-sm-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
    .col-sm-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
    .col-sm-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
    .col-sm-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
    .col-sm-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
    .col-sm-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
    .col-sm-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
    .col-sm-offset-0{margin-left:0}
    .col-sm-offset-1{margin-left:8.33333333%}
    .col-sm-offset-2{margin-left:16.66666667%}
    .col-sm-offset-3{margin-left:25%}
    .col-sm-offset-4{margin-left:33.33333333%}
    .col-sm-offset-5{margin-left:41.66666667%}
    .col-sm-offset-6{margin-left:50%}
    .col-sm-offset-7{margin-left:58.33333333%}
    .col-sm-offset-8{margin-left:66.66666667%}
    .col-sm-offset-9{margin-left:75%}
    .col-sm-offset-10{margin-left:83.33333333%}
    .col-sm-offset-11{margin-left:91.66666667%}
    .display-flex-sm{display:-webkit-box;display:-ms-flexbox;display:flex}
    .start-sm{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
    .center-sm{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
    .end-sm{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
    .top-sm{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
    .middle-sm{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
    .bottom-sm{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
    .self-bottom-sm{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
    .around-sm{-ms-flex-pack:distribute;justify-content:space-around}
    .between-sm{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
    .first-sm{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
    .last-sm{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
  }
  @media screen and (min-width:64em){
    .col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-offset-0,.col-md-offset-1,.col-md-offset-2,.col-md-offset-3,.col-md-offset-4,.col-md-offset-5,.col-md-offset-6,.col-md-offset-7,.col-md-offset-8,.col-md-offset-9,.col-md-offset-10,.col-md-offset-11,.col-md-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
    .col-md{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
    .col-md-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
    .col-md-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
    .col-md-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
    .col-md-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
    .col-md-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
    .col-md-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
    .col-md-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
    .col-md-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
    .col-md-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
    .col-md-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
    .col-md-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
    .col-md-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
    .col-md-offset-0{margin-left:0}
    .col-md-offset-1{margin-left:8.33333333%}
    .col-md-offset-2{margin-left:16.66666667%}
    .col-md-offset-3{margin-left:25%}
    .col-md-offset-4{margin-left:33.33333333%}
    .col-md-offset-5{margin-left:41.66666667%}
    .col-md-offset-6{margin-left:50%}
    .col-md-offset-7{margin-left:58.33333333%}
    .col-md-offset-8{margin-left:66.66666667%}
    .col-md-offset-9{margin-left:75%}
    .col-md-offset-10{margin-left:83.33333333%}
    .col-md-offset-11{margin-left:91.66666667%}
    .display-flex-md{display:-webkit-box;display:-ms-flexbox;display:flex}
    .start-md{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
    .center-md{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
    .end-md{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
    .top-md{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
    .middle-md{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
    .bottom-md{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
    .self-bottom-md{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
    .around-md{-ms-flex-pack:distribute;justify-content:space-around}
    .between-md{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
    .first-md{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
    .last-md{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
  }
  @media screen and (min-width:75em){
    .col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-offset-0,.col-lg-offset-1,.col-lg-offset-2,.col-lg-offset-3,.col-lg-offset-4,.col-lg-offset-5,.col-lg-offset-6,.col-lg-offset-7,.col-lg-offset-8,.col-lg-offset-9,.col-lg-offset-10,.col-lg-offset-11,.col-lg-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
    .col-lg{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
    .col-lg-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
    .col-lg-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
    .col-lg-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
    .col-lg-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
    .col-lg-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
    .col-lg-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
    .col-lg-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
    .col-lg-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
    .col-lg-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
    .col-lg-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
    .col-lg-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
    .col-lg-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
    .col-lg-offset-0{margin-left:0}
    .col-lg-offset-1{margin-left:8.33333333%}
    .col-lg-offset-2{margin-left:16.66666667%}
    .col-lg-offset-3{margin-left:25%}
    .col-lg-offset-4{margin-left:33.33333333%}
    .col-lg-offset-5{margin-left:41.66666667%}
    .col-lg-offset-6{margin-left:50%}
    .col-lg-offset-7{margin-left:58.33333333%}
    .col-lg-offset-8{margin-left:66.66666667%}
    .col-lg-offset-9{margin-left:75%}
    .col-lg-offset-10{margin-left:83.33333333%}
    .col-lg-offset-11{margin-left:91.66666667%}
    .display-flex-lg{display:-webkit-box;display:-ms-flexbox;display:flex}
    .start-lg{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
    .center-lg{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
    .end-lg{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
    .top-lg{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
    .middle-lg{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
    .bottom-lg{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
    .self-bottom-lg{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
    .around-lg{-ms-flex-pack:distribute;justify-content:space-around}
    .between-lg{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
    .first-lg{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
    .last-lg{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
  }
  .hide{display:none!important}
  .show{display:block!important}
  @media screen and (max-width:47.9375em){.hide-for-xs-only{display:none!important}}
  @media screen and (min-width:48em) and (max-width:63.9375em){.hide-for-sm-only{display:none!important}}
  @media screen and (min-width:64em){.hide-for-md{display:none!important}}
  @media screen and (max-width:63.9375em){.show-for-md{display:none!important}}
  .text--left{text-align:left}
  .text--center{text-align:center}
  @media screen and (min-width:64em){.md-text--center{text-align:center}}
  .layout{max-width:75rem;margin:0 auto;position:relative}
  .layout--corpo,.layout--full-width{width:100%;max-width:100%}
  .c-button{display:inline-block;vertical-align:middle;padding:.8125rem 1.875rem;-webkit-appearance:none;border-radius:1.375rem;transition:background-color .25s ease-out,color .25s ease-out;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.625rem;line-height:1;letter-spacing:.0625rem;text-align:center;cursor:pointer;text-decoration:none;text-transform:uppercase;background:transparent;border:.0625rem solid #cacaca;color:#000}
  @media screen and (min-width:48em){.c-button{font-size:.75rem;padding:.9375rem 1.875rem}}
  .c-button .c-button:focus,.c-button:hover{text-decoration:none;background-color:transparent;border-color:#cacaca;color:#000;outline:none}
  .c-button[disabled]:not(.c-button--inactive){opacity:.65;cursor:not-allowed}
  .c-button--secondary{display:inline-block;vertical-align:middle;padding:.8125rem 1.875rem;-webkit-appearance:none;border-radius:1.375rem;transition:background-color .25s ease-out,color .25s ease-out;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.625rem;line-height:1;letter-spacing:.0625rem;text-align:center;cursor:pointer;text-decoration:none;text-transform:uppercase;background:transparent;border:.0625rem solid #cacaca;color:#000}
  @media screen and (min-width:48em){.c-button--secondary{font-size:.75rem;padding:.9375rem 1.875rem}}
  .c-button--secondary .c-button--secondary:focus,.c-button--secondary:hover{text-decoration:none;background-color:#000;border-color:#cacaca;color:#fff;outline:none}
  .c-input--fullwidth{width:100%}
  input::-ms-clear,input::-ms-reveal{display:none}
  .sr-only{border:0!important;clip:rect(1px,1px,1px,1px)!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important;white-space:nowrap!important}
  .c-pagedesigner{color:#000}
  .c-pagedesigner .c-background__image-container{position:absolute;top:0}
  @media screen and (min-width:64em){.c-pagedesigner .c-background__image-container{position:relative}}
  @media screen and (min-width:64em){.c-pagedesigner .c-background__image{position:absolute;left:50%;transform:translateX(-50%);max-width:none}}
  .c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat2 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat3 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat4 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat5 .has-image{margin-bottom:4.6875rem}
  .c-pagedesigner__text-content{margin-bottom:2.1875rem}
  .c-pagedesigner__title-wrapper{margin-top:1.25rem}
  @media screen and (min-width:64em){.c-pagedesigner__title-wrapper{margin-top:3.125rem}}
  @media screen and (min-width:75em){.c-pagedesigner__title-wrapper{margin-top:3.125rem}}
  .c-pagedesigner__title{padding:0 1.0625rem}
  @media screen and (min-width:48em){.c-pagedesigner__title{padding:0 3.875rem}}
  @media screen and (min-width:64em){.c-pagedesigner__title{padding:0 1.875rem}}
  @media screen and (min-width:75em){.c-pagedesigner__title{padding:0}}
  .c-pagedesigner__title p{margin:0}
  .c-pagedesigner__subtitle{margin-top:.6875rem;padding:0 1.0625rem}
  @media screen and (min-width:48em){.c-pagedesigner__subtitle{padding:0 3.875rem}}
  @media screen and (min-width:64em){.c-pagedesigner__subtitle{padding:0 1.875rem}}
  @media screen and (min-width:75em){.c-pagedesigner__subtitle{padding:0}}
  .c-pagedesigner__module-space{padding:2.5rem 1.0625rem 2.8125rem}
  @media screen and (min-width:48em){.c-pagedesigner__module-space{padding:3.125rem}}
  .c-pagedesigner .experience-layouts-strat3+.experience-layouts-2column .c-pagedesigner__module-space-background,.c-pagedesigner__module-space-background{margin-top:0}
  .c-pagedesigner a{text-decoration:underline}
  .c-pagedesigner a:hover{text-decoration:none;color:#c4926d!important}
  .c-pagedesigner__button-space{margin:1.25rem 0 2.5rem}
  @media screen and (min-width:64em){.c-pagedesigner__button-space{margin:1.25rem 0 3.125rem}}
  @media screen and (min-width:75em){.c-pagedesigner__button-space{margin:1.25rem 0 4.6875rem}}
  .c-pagedesigner .c-button{margin-top:1.5625rem;text-decoration:none;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
  @media screen and (min-width:48em){.c-pagedesigner .c-button{margin-top:2.1875rem}}
  @media screen and (min-width:64em){.c-pagedesigner .c-button{margin-top:2.5rem}}
  .c-pagedesigner .c-button:hover{color:#fff!important}
  .c-text-image{display:block;text-decoration:none}
  .c-text-image__title{margin-top:.6875rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;text-transform:none}
  @media screen and (min-width:48em){.c-text-image__title{margin-top:1.0625rem}}
  .c-text-image__tag{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#fff;padding:.3125rem .625rem;display:inline-block}
  .c-text-image__tag--secondary{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;letter-spacing:.0625rem;padding:0 .625rem}
  .c-text-image–-secondary,.c-text-image–-secondary .c-text-image__visual{position:relative}
  @media screen and (min-width:64em){
    .c-text-image–-secondary .c-text-image__visual:after{content:"";position:absolute;width:100%;height:100%;background:transparent;top:0;left:0;-webkit-transition:background .5s ease-in-out;transition:background .5s ease-in-out}
    .c-text-image–-secondary .c-text-image__visual:hover:after{background:rgba(0,0,0,.4)}
  }
  .c-text-image–-secondary .c-text-image__visual-title{font-size:1.25rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#fff;text-align:center;line-height:1;text-decoration:none;width:100%;position:absolute;top:0;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;z-index:1}
  .c-text-image–-secondary .c-text-image__visual-title:before{content:"";width:100%;height:100%;top:0;left:0;position:absolute;z-index:1}
  .c-text-image–-secondary .c-text-image__visual-title--thin{font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;line-height:1.25rem}
  @media screen and (min-width:48em){.c-text-image–-secondary .c-text-image__visual-title--thin{line-height:2.5rem}}
  .c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:1.875rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;letter-spacing:-.05rem;display:block}
  .c-text-image–-secondary .c-text-image__visual-title--secondary{font-size:1.875rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;top:50%;left:50%;transform:translate(-50%,-50%);height:auto;display:inline-block}
  .c-text-image–-secondary .c-text-image__visual-title--top{position:absolute;top:-.5625rem;left:50%;transform:translate(-50%)}
  @media screen and (min-width:48em){.c-text-image–-secondary .c-text-image__visual-title{font-size:2.5rem}.c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:3.75rem;letter-spacing:-.075rem}}
  .c-text-image–-secondary .c-text-image__content{display:flex}
  .c-text-image–-secondary .c-text-image__content .c-text-image__text{flex-grow:1;width:0;text-align:left}
  .c-text-image–-secondary .c-text-image__description{font-size:.875rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#575757;max-width:24.375rem;padding-top:.3125rem}
  @media screen and (min-width:64em){.c-text-image–-secondary .c-text-image__description{margin-top:.625rem}}
  .c-content-carousel__item{padding:0 .625rem;text-align:center}
  @media screen and (min-width:48em){.c-content-carousel__item{padding:0 .75rem}}
  @media screen and (min-width:64em){.c-content-carousel__item{padding:0 .5rem}}
  .c-editorial-push{display:flex;justify-content:center;margin:0 0 2.1875rem;width:100%}
  .c-editorial-push a{text-decoration:none;width:100%}
  .c-editorial-push .c-text-image–-secondary .c-text-image__visual-title{font-size:1.25rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#fff;text-align:center;line-height:1;text-decoration:none;display:inline-block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:auto}
  @media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title{margin-top:0}}
  .c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--thin{font-size:1.25rem;line-height:2.5rem;font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif}
  @media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--thin{font-size:2.5rem}}
  .c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:1.875rem}
  @media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:3.75rem}}
  .c-editorial-push .c-text-image__visual{width:100%;overflow:hidden}
  @media screen and (min-width:64em){.c-editorial-push .c-text-image__visual{height:auto}}
  @media screen and (min-width:48em){.c-editorial-push{margin:0 0 5rem}}
  @media screen and (min-width:64em){.c-editorial-push{margin:0 0 3.125rem}}
  .c-strat1__background{bottom:0;top:unset}
  @media screen and (min-width:48em) and (max-width:63.9375em){.c-strat1__background{width:100%}}
  .c-strat1__margin-top{margin-top:3.125rem}
  @media screen and (min-width:48em){.c-strat1__margin-top{margin-top:4.6875rem}}
  .c-strat1--col{padding:0 .5625rem}
  .c-strat1--col .c-img-start1{margin-bottom:3.125rem}
  @media screen and (min-width:64em){.c-strat1--col .c-img-start1{margin-bottom:0}}
  .c-strat1__main-image{padding:0 2.0625rem}
  @media screen and (min-width:48em){.c-strat1__main-image{padding:0 1.875rem}}
  @media screen and (min-width:64em){.c-strat1__main-image{padding:0 3.8125rem}}
  @media screen and (min-width:75em){.c-strat1__main-image{padding:0}}
  @media screen and (min-width:48em) and (max-width:63.9375em){.c-strat1 .c-background__image{width:100%;max-width:100%}}
  .c-strat1 .c-pagedesigner__title{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.9375rem;line-height:1.25rem;letter-spacing:.125rem;text-transform:uppercase;margin-bottom:1.875rem;padding:0}
  @media screen and (min-width:48em){.c-strat1 .c-pagedesigner__title-wrapper{margin-bottom:3.125rem;margin-top:0}}
  .c-strat1 .c-pagedesigner__subtitle{padding:0}
  .c-strat1 .c-pagedesigner__subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-strat1 .c-pagedesigner__subtitle p{font-size:2.25rem;line-height:2.4375rem}}
  .c-strat1 .c-pagedesigner__subtitle p:last-child{margin-bottom:0}
  .c-strat1 .c-pagedesigner__subtitle a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;color:inherit}
  @media screen and (min-width:48em){.c-strat1 .c-pagedesigner__subtitle a{font-size:2.25rem;line-height:2.4375rem}}
  .c-strat1 .c-button-wrapper{min-width:8.625rem}
  @media screen and (min-width:64em){.c-strat1 .c-button-wrapper{min-width:9.5rem}}
  .c-strat1--rowA,.c-strat1--rowB,.c-strat1--rowC{margin-top:0}
  @media screen and (min-width:64em){.c-strat1--rowA--last .c-img-start1,.c-strat1--rowB--last .c-img-start1,.c-strat1--rowC--last .c-img-start1{margin-top:3.125rem}}
  .c-strat1 .c-button{margin:1.875rem 0 0;font-size:.625rem;letter-spacing:.0625rem;width:auto}
  @media screen and (min-width:64em){.c-strat1 .c-button{font-size:.75rem}}
  .c-strat1 .row-with-template{margin-bottom:3.125rem}
  @media screen and (min-width:48em){.c-strat1 .row-with-template{padding-top:0;margin-bottom:0}}
  @media screen and (min-width:48em){.c-strat1 .c-background__content-wrapper{padding:4.6875rem 2.8125rem}}
  @media screen and (min-width:75em){.c-strat1 .c-background__content-wrapper{padding:4.6875rem 0}}
  .c-strat1.c-strat1--image{padding:4.6875rem 0}
  @media screen and (min-width:64em){.c-strat1.c-strat1--image{padding:0}}
  @media screen and (min-width:48em){.c-img-start1{padding:0 .125rem}}
  @media screen and (min-width:64em){.c-img-start1{padding:0}}
  .c-img-start1 .img.c-img-start1--text-wrapper{margin-top:1.25rem}
  .c-img-start1__elements{display:flex;flex-direction:column}
  .c-img-start1__imagevideo-wrapper{order:1}
  .c-img-start1__text-wrapper{display:flex;order:3}
  .c-img-start1--title{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;line-height:1.5rem;text-transform:none;font-size:.8125rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-img-start1--title{font-size:1rem}}
  .c-img-start1--subtitle{margin-top:1.25rem}
  .c-img-start1--subtitle p{margin-bottom:0}
  .c-img-start1--subtitle a,.c-img-start1--subtitle p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:.8125rem;line-height:1.3125rem}
  @media screen and (min-width:48em){.c-img-start1--subtitle a,.c-img-start1--subtitle p{font-size:1rem;line-height:1.5rem}}
  .c-img-start1--subtitle a{color:inherit}
  .c-img-start1--subtitle p:last-child{margin-bottom:0;margin-top:0}
  @media screen and (min-width:48em){.c-img-start1--subtitle p:last-child{margin-bottom:0}}
  .c-img-start1 .no-title .c-img-start1--subtitle{margin-top:0}
  .c-img-start1 .wrapper-img .c-img-start1--subtitle,.c-img-start1 .wrapper-img .c-img-start1--title{margin-top:1.25rem}
  @media screen and (min-width:48em){.c-img-start1 .wrapper-img .no-title .c-img-start1--subtitle{margin-top:1.25rem}}
  .c-img-start1 .subtitle-content{margin-top:1.25rem}
  .c-strat2__main-image{text-align:center;padding:4.6875rem 0}
  @media screen and (min-width:48em){.c-strat2__main-image{padding:4.6875rem 1.875rem}}
  @media screen and (min-width:75em){.c-strat2__main-image{padding:4.6875rem 0}}
  .c-strat2--image{padding:0}
  .c-strat2--image .has-image{margin-bottom:4.6875rem}
  .c-strat2__image-wrapper,.c-strat2__title-wrapper-bottom{margin-top:3.125rem}
  .c-strat2__title h2{color:inherit;font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.5rem;line-height:2.625rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-strat2__title h2{font-size:4.7rem;line-height:4.25rem}}
  .c-strat2__title h2:last-child{margin-bottom:1.25rem}
  .c-strat2__title h2 a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
  .c-strat2__big-p{color:inherit;text-align:center}
  .c-strat2__big-p p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:1rem;line-height:1.5rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-strat2__big-p p{font-size:1.5625rem;line-height:2rem}}
  .c-strat2__big-p p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
  .c-strat2__regular-p{color:inherit;text-align:center;margin-top:1.25rem}
  .c-strat2__regular-p p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:.8125rem;line-height:1.3125rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-strat2__regular-p p{font-size:1rem;line-height:1.5rem}}
  .c-strat2__regular-p p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
  .c-strat2 .c-button{margin:1.875rem 0 0;font-size:.625rem;letter-spacing:.0625rem;width:auto}
  @media screen and (min-width:64em){.c-strat2 .c-button{font-size:.75rem}}
  .c-strat3{padding:4.6875rem 1.125rem 1.5625rem}
  @media screen and (min-width:48em){.c-strat3{padding:4.6875rem 2.0625rem 1.5625rem}}
  @media screen and (min-width:64em){.c-strat3{padding:4.6875rem 0 1.5625rem}}
  .c-strat3__title{font-size:.9375rem;line-height:1.25rem;letter-spacing:.125rem}
  .c-strat3__title,.c-strat3__title a{color:inherit;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
  .c-strat3__title a{font-size:inherit}
  .c-strat3__title-wrapper{margin-bottom:3.125rem}
  .c-strat3__subtitle{color:inherit;margin-top:1.25rem}
  .c-strat3__subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-strat3__subtitle p{font-size:2.25rem;line-height:2.4375rem}}
  .c-strat3__subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
  .c-strat3 .c-button-wrapper{margin-top:1.875rem}
  .c-strat3 .c-img-start3{margin-bottom:3.125rem}
  .c-strat3 .c-img-start3__img-subtitle{margin-top:3.125rem}
  .c-strat3 .c-img-start3__img-subtitle p{font-family:"Microsoft YaHei","MicrosoftJhengHei",PlayfairDisplay-Regular,arial,sans-serif;font-size:14px;line-height:1.125rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-strat3 .c-img-start3__img-subtitle p{font-size:22px;line-height:1.8375rem}}
  .c-strat3 .c-img-start3__img-subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
  .c-strat3 .c-button{margin:0;font-size:.625rem;letter-spacing:.0625rem;width:auto}
  @media screen and (min-width:64em){.c-strat3 .c-button{font-size:.75rem}}
  .c-strat4{padding:4.6875rem 1.0625rem}
  @media screen and (min-width:48em){.c-strat4{padding:4.6875rem 2.4375rem}}
  @media screen and (min-width:64em){.c-strat4{padding:4.6875rem 0}}
  .c-strat4__content-wrapper{margin:0 auto;padding:0 .75rem}
  @media screen and (min-width:48em){.c-strat4__content-wrapper{padding:0}}
  .c-strat4__subtitle{color:inherit}
  .c-strat4__subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;margin-bottom:0}
  @media screen and (min-width:48em){.c-strat4__subtitle p{font-size:2.25rem;line-height:2.4375rem}}
  .c-strat4__subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
  .c-strat4__subtitle p strong{font-family:PlayfairDisplay-Bold,arial,sans-serif;font-weight:400}
  .c-strat4__content{color:inherit;margin-top:1.875rem;text-align:left}
  .c-strat4__content p{margin-bottom:0;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;line-height:1.3125rem;font-size:.8125rem}
  @media screen and (min-width:48em){.c-strat4__content p{font-size:1rem;line-height:1.5rem}}
  .c-strat4__content p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
  .c-strat4__content2{margin-top:1.875rem}
  .c-strat4 .template_a{display:flex;flex-direction:row;flex-wrap:wrap}
  .c-strat4 .template_a .c-strat4__subtitle{order:2;width:100%}
  @media screen and (min-width:64em){.c-strat4 .template_a .c-strat4__subtitle{order:3}}
  @media screen and (min-width:64em){.c-strat4 .template_a .c-strat4__content-wrapper{padding:0 .3125rem}}
  @media screen and (min-width:64em) and (max-width:74.9375em){.c-strat4 .template_a .c-strat4__image-container{margin-left:4.25rem}}
  .c-strat4 .template_a .c-strat4__image-wrapper{order:3}
  .c-strat4 .template_a .c-strat4__content{order:4;width:100%;margin-top:3.125rem}
  @media screen and (min-width:64em){.c-strat4 .template_a .c-strat4__content{margin-top:1.875rem}}
  .c-strat4 .template_a .img-teamplate-b{display:block;margin-top:3.125rem}
  @media screen and (min-width:64em){.c-strat4 .template_a .img-teamplate-b{display:none}}
  .c-strat4 .template_b{display:flex;flex-direction:row;flex-wrap:wrap}
  .c-strat4 .template_b .c-strat4__subtitle{order:2;width:100%}
  .c-strat4 .template_b .c-strat4__image-wrapper{order:3;width:100%}
  .c-strat4 .template_b .c-strat4__image {margin-top:3.125rem}
  .c-strat4 .template_b .c-strat4__content{order:4;width:100%;margin-top:3.125rem}
  @media screen and (min-width:64em){.c-strat4 .template_b .c-strat4__content-wrapper{padding:0 .625rem}}
  .c-strat4 .c-button-wrapper{order:5;width:100%;margin-top:1.875rem}
  .c-strat4 .c-button{margin:0;font-size:.625rem;letter-spacing:.0625rem;width:auto}
  @media screen and (min-width:64em){.c-strat4 .c-button{font-size:.75rem}}
  .c-strat1 .c-pagedesigner__subtitle.reset-style p{
    font-family: "Microsoft YaHei","MicrosoftJhengHei",PlayfairDisplay-Regular,arial,sans-serif;
    font-size: 16px;
    line-height: 28px;
  }
  .c-strat4__subtitle.reset-style p {
    font-family: "Microsoft YaHei","MicrosoftJhengHei",PlayfairDisplay-Regular,arial,sans-serif;
    font-size: 16px;
    line-height: 28px;
  }
  @media screen and (min-width:64em){
  .c-strat1 .c-pagedesigner__subtitle.reset-style p{
    font-size: 22px;
    line-height: 30px;
  }
  .c-strat4__subtitle.reset-style p {
    font-size: 22px;
    line-height: 30px;
  }
}
</style>